import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-right-gray.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_2 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = { class: "grid grid-cols-2" }
const _hoisted_4 = { class: "text-20px text-black-lp-300 col-span-2 capitalize font-semibold" }
const _hoisted_5 = { class: "flex flex-row col-span-2 text-gray-lp-600" }
const _hoisted_6 = { class: "pr-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "arrow-right"
}, null, -1)
const _hoisted_8 = { class: "pl-2 mr-6" }
const _hoisted_9 = { class: "px-6 border-l border-gray-lp-400" }
const _hoisted_10 = {
  key: 0,
  class: "pl-6 pr-2 border-l border-gray-lp-400"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_0,
  class: "w-5",
  alt: "arrow-right"
}
const _hoisted_12 = {
  key: 2,
  class: "pl-2 pr-6"
}
const _hoisted_13 = {
  key: 3,
  class: "px-6 border-l border-gray-lp-400"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "w-full space-y-6"
}
const _hoisted_16 = { class: "grid gap-6 grid-cols-2" }
const _hoisted_17 = { class: "grid gap-6 grid-cols-4" }
const _hoisted_18 = {
  key: 1,
  class: "grid gap-6 grid-cols-2 w-3/4"
}
const _hoisted_19 = { class: "flex flex-row gap-6" }
const _hoisted_20 = { class: "flex-grow" }
const _hoisted_21 = { class: "w-40" }
const _hoisted_22 = { class: "flex flex-row gap-6" }
const _hoisted_23 = { class: "flex-grow" }
const _hoisted_24 = { class: "w-32" }
const _hoisted_25 = { class: "grid gap-4 grid-cols-4 w-full" }
const _hoisted_26 = { class: "w-2/12" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_28 = {
  key: 3,
  class: "flex items-end flex-col gap-2 w-full"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "py-2" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "flex items-end justify-between" }, null, -1)
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_36 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_38 = { class: "col-span-4 space-y-1" }
const _hoisted_39 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_41 = { class: "text-12px text-black-lp-300" }
const _hoisted_42 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_43 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_44 = { class: "text-12px text-black-lp-300" }
const _hoisted_45 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DimensionPerKoli = _resolveComponent("DimensionPerKoli")!
  const _component_WeightSummaryStt = _resolveComponent("WeightSummaryStt")!
  const _component_WeightSummaryTimbangUlang = _resolveComponent("WeightSummaryTimbangUlang")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('Ubah Cargo'),
        "vertical-separator": false,
        fullPage: "",
        "is-floating-action": ""
      }, {
        data: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Icons, {
              name: _ctx.cargoType.icon,
              class: "w-8 mr-4 text-gray-lp-600"
            }, null, 8, ["name"]),
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, _toDisplayString(`${_ctx.$t('Kargo')} ${_ctx.$t(_ctx.cargoType.label)}`), 1),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.detailData.originCityCode) + " - " + _toDisplayString(_ctx.detailData.originCityName), 1),
                _hoisted_7,
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.detailData.destinationCityCode) + " - " + _toDisplayString(_ctx.detailData.destinationCityName), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.detailData.departureDate)), 1),
                (_ctx.detailData.cargoType === 'plane')
                  ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.formatTimeNumber(_ctx.detailData.departureDate)), 1))
                  : _createCommentVNode("", true),
                (_ctx.detailData.cargoType === 'plane')
                  ? (_openBlock(), _createBlock("img", _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.detailData.cargoType === 'plane')
                  ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.formatTimeNumber(_ctx.detailData.arrivalDate)), 1))
                  : _createCommentVNode("", true),
                (_ctx.detailData.cargoType === 'plane')
                  ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.detailData.totalVolumeWeight > _ctx.detailData.totalGrossWeight
                    ? _ctx.detailData.totalVolumeWeight
                    : _ctx.detailData.totalGrossWeight) + " Kg", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_14,
          (_ctx.detailData.cargoType === 'plane')
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_DataWrapper, {
                    label: `No. ${_ctx.$t('kargo')}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_cargo_number_edit_cargo",
                        modelValue: _ctx.detailData.cargoNumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.cargoNumber = $event)),
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: `${_ctx.$t('No. penerbangan')}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_vehicle_number_edit_cargo",
                        modelValue: _ctx.detailData.vehiclePoliceNumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.vehiclePoliceNumber = $event)),
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Komoditas group (kargo)')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_cargo_commodity_edit_cargo",
                        modelValue: _ctx.detailData.cargoCommodity,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.cargoCommodity = $event)),
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, { label: "NOG" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_cargo_nog_edit_cargo",
                        modelValue: _ctx.detailData.nog,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.nog = $event)),
                        type: "textarea",
                        placeholder: _ctx.$t('Masukan NOG'),
                        maxLength: 100,
                        textAreaRows: "1",
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, { label: "SHC" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_shc_edit_cargo",
                        modelValue: _ctx.shcValue,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.shcValue = $event)),
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('Produk kargo')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        id: "input_cargo_product_edit_cargo",
                        modelValue: _ctx.detailData.cargoProduct,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailData.cargoProduct = $event)),
                        disabled: "",
                        disableBackground: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_18, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Nama Partner')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.partnerName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailData.partnerName = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Tipe User')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.typeUser,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.typeUser = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Komoditas Kargo')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.cargoCommodity,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.detailData.cargoCommodity = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('Produk Kargo')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.cargoProduct,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailData.cargoProduct = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: `No. ${_ctx.$t('Kargo')}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.cargoNumber,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailData.cargoNumber = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: `${_ctx.$t('No. Seri Kendaraan')}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailData.vehiclePoliceNumber,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.detailData.vehiclePoliceNumber = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Tanggal Keberangkatan')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Datepicker, {
                          class: "mt-2",
                          modelValue: _ctx.departureDate,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.departureDate = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Waktu Berangkat')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Datepicker, {
                          class: "mt-2",
                          modelValue: _ctx.departureDate,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.departureDate = $event)),
                          showDatePicker: false,
                          showTimePicker: true,
                          disabled: "",
                          placeholder: _ctx.$t('Pilih waktu')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Tanggal Kedatangan')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Datepicker, {
                          class: "mt-2",
                          modelValue: _ctx.arrivalDate,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.arrivalDate = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('Waktu Tiba')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Datepicker, {
                          class: "mt-2",
                          modelValue: _ctx.arrivalDate,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.arrivalDate = $event)),
                          showDatePicker: false,
                          showTimePicker: true,
                          disabled: "",
                          placeholder: _ctx.$t('Pilih waktu')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ])
              ])),
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('No. STT/bagging'),
              class: "col-span-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  error: _ctx.errorSttNumber !== '' || _ctx.isUnpaid || _ctx.isDiffDestination,
                  onChange: _ctx.onCloseNotification,
                  isErrorIconInput: false,
                  isErrorIconCaption: false,
                  errorCaption: _ctx.errorSttNumber,
                  ref: "inputStt",
                  onEnter: _ctx.addScanSttNumber,
                  sizeInput: "24px",
                  labelStacked: 
                _ctx.$t('Contoh: no. STT/bagging: 99LP1234567890123/88-22-12345678')
              ,
                  modelValue: _ctx.scanNumber,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.scanNumber = $event)),
                  placeholder: _ctx.$t('Masukkan nomor STT/bagging atau scan barcode'),
                  bold: !!_ctx.scanNumber
                }, null, 8, ["error", "onChange", "errorCaption", "onEnter", "labelStacked", "modelValue", "placeholder", "bold"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_ScanFailedCard, { data: _ctx.scanFailedList }, null, 8, ["data"])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.addSttNumber,
              customClass: "px-12 py-2.5",
              title: _ctx.$t('Tambah'),
              textColor: "white",
              disabled: _ctx.isDisableAddSttNumber
            }, null, 8, ["onClick", "title", "disabled"])
          ]),
          _hoisted_27,
          (!_ctx.showEditDimensiPerKoliV1 && _ctx.showNewDimensionPerKoli)
            ? (_openBlock(), _createBlock(_component_DimensionPerKoli, {
                key: 2,
                isEdit: true
              }))
            : (_openBlock(), _createBlock("div", _hoisted_28, [
                _createVNode(_component_WeightSummaryStt, {
                  grossWeight: _ctx.sttCalculation.grossWeight,
                  volumeWeight: _ctx.sttCalculation.volumeWeight
                }, null, 8, ["grossWeight", "volumeWeight"]),
                _hoisted_29,
                _createVNode(_component_WeightSummaryTimbangUlang, {
                  modelValue: _ctx.detailData,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.detailData = $event)),
                  isDimensionChanged: _ctx.isDimensionChanged,
                  "onUpdate:isDimensionChanged": _cache[19] || (_cache[19] = ($event: any) => (_ctx.isDimensionChanged = $event)),
                  isEditFirstLanding: _ctx.isEditFirstLanding,
                  "onUpdate:isEditFirstLanding": _cache[20] || (_cache[20] = ($event: any) => (_ctx.isEditFirstLanding = $event)),
                  actualChargeableWeight: _ctx.actualChargeableWeight,
                  isEdit: true,
                  isErrorEditWeight: _ctx.isErrorChargeableWeight
                }, null, 8, ["modelValue", "isDimensionChanged", "isEditFirstLanding", "actualChargeableWeight", "isErrorEditWeight"]),
                (_ctx.isShowUploadPhotoSection)
                  ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                      key: 0,
                      class: "w-full",
                      title: "Upload bukti foto untuk ubah berat",
                      marginBottom: false,
                      defaultOpened: true,
                      showViewAdjustment: _ctx.openAdjustmentWeight,
                      "onUpdate:showViewAdjustment": _cache[21] || (_cache[21] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                      modelValue: _ctx.detailData.photoProof,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.detailData.photoProof = $event)),
                      onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                      onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                      onShowViewAdjustment: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight))
                    }, null, 8, ["showViewAdjustment", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
                  : _createCommentVNode("", true)
              ])),
          _hoisted_30,
          _hoisted_31,
          _createVNode("div", _hoisted_32, [
            _createVNode(_component_TableV2, {
              data: _ctx.sttResultFinal,
              columns: _ctx.columns,
              borderTop: false,
              pagination: _ctx.pagination,
              "is-hard-pagination": true,
              "is-quick-search": true,
              "is-sorting": true,
              "pagination-style": "v2",
              customButtonAction: _ctx.customButton,
              autoHeight: "",
              isEmpty: _ctx.isSttEmpty,
              emptyMessage: _ctx.$t('Tidak ada STT atau bagging di dalam kargo ini'),
              totalColumnFreeze: 1,
              isRightFreeze: true
            }, {
              "top-left-table": _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }, 8, ["data", "columns", "pagination", "customButtonAction", "isEmpty", "emptyMessage"])
          ])
        ]),
        "top-right": _withCtx(() => [
          _createVNode("div", null, [
            _createVNode(_component_LpButton, {
              onClick: _cache[24] || (_cache[24] = e => _ctx.isFormValid && _ctx.togglePanel(e)),
              icon: 
                _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
              ,
              title: _ctx.$t('Process'),
              textColor: "white",
              disabled: !_ctx.isFormValid || _ctx.isLoadingCalculateVolume,
              id: "button_process_edit_cargo"
            }, null, 8, ["icon", "title", "disabled"]),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpButton, {
                  class: "w-60",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createAndPrint(false))),
                  flat: "",
                  dense: "",
                  iconLeft: "cargo",
                  title: _ctx.$t('Ubah Kargo')
                }, null, 8, ["title"]),
                _hoisted_34,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.createAndPrint(true))),
                  flat: "",
                  dense: "",
                  iconLeft: "printer",
                  title: _ctx.$t('Ubah & Print PDF')
                }, null, 8, ["title"]),
                _hoisted_35,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.createAndPrint(false, true))),
                  flat: "",
                  dense: "",
                  iconLeft: "invoice-gray",
                  title: _ctx.$t('Ubah & Print Label')
                }, null, 8, ["title"])
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.isPartial || _ctx.isFailed ? 'Download' : 'OK',
      textCancel: _ctx.isPartial || _ctx.isFailed ? 'OK' : '',
      class: "px-8",
      customButton: _ctx.isPartial || _ctx.isFailed ? 'px-10' : 'px-6'
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode("div", _hoisted_38, [
            _withDirectives(_createVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode("div", _hoisted_41, _toDisplayString(_ctx.countSuccess) + " " + _toDisplayString(_ctx.$t('No. STT Sukses')), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode("div", _hoisted_44, _toDisplayString(_ctx.countFailed) + " " + _toDisplayString(_ctx.$t('No. STT Gagal')), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, _ctx.openSuccess || _ctx.isErrorTyping || _ctx.isFailed || _ctx.isPartial]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('Yakin ingin keluar?'),
      message: _ctx.$t('Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('Keluar'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.$t('bagging.baggingConfirmationEditTitle'),
      message: _ctx.$t('cargo.confirmSubtitleEditCargo', {cargoNo: _ctx.detailData.cargoNumber}),
      image: "are-you-sure",
      textSuccess: _ctx.$t('Simpan'),
      textCancel: _ctx.$t('Batal'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.popUpDelete?.success?.action,
      onClose: _ctx.popUpDelete?.cancel?.action,
      title: _ctx.popUpDelete?.title,
      message: _ctx.popUpDelete?.message,
      image: _ctx.popUpDelete?.image,
      textSuccess: _ctx.popUpDelete?.success?.text,
      textCancel: _ctx.popUpDelete?.cancel?.text,
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isShowModalDeleteConfirmation || _ctx.successModalDelete]
    ]),
    _createVNode(_component_Notification, {
      titleMessageError: _ctx.$t('No. STT/bagging tidak bisa di booking cargo'),
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.notification = $event)),
      status: _ctx.isErrorNotification ? 'error' : 'success',
      onClose: _ctx.onCloseNotification,
      messageError: _ctx.messageErrorNotification
    }, null, 8, ["titleMessageError", "data", "modelValue", "status", "onClose", "messageError"]),
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_45, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}